import React, { memo, RefObject } from "react";
import { UseFormRegister, FieldError } from "react-hook-form";
import ErrorsMessage from "app/components/common/errors/ErrorsMessage";
import UploadIcon from "app/assets/icons/UploadIcon";
import DeleteIcon from "app/assets/icons/DeleteIcon";
import pdf_icon from "app/assets/icons/pdf_icon.svg";

interface PassportImageUploadProps {
  previewUrl: string | null;
  fieldName: string;
  savedFileUrl: string;
  register: UseFormRegister<any>;
  error?: FieldError;
  fileInputRef: RefObject<HTMLInputElement>;
  handleFileChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onChooseFileClick: () => void;
  onDelete: (key: string) => void;
  imageObject?: File | null;
  isChecked: boolean;
}

const PassportImageUpload: React.FC<PassportImageUploadProps> = ({
  previewUrl,
  fieldName = "",
  savedFileUrl,
  register,
  error,
  fileInputRef,
  handleFileChange,
  onChooseFileClick,
  onDelete,
  imageObject,
  isChecked,
}) => {
  return (
    <div className="text-left">
      {previewUrl ? (
        <div
          className={`bg-[#EAECF0] p-5  text-center rounded-[20px] relative ${
            !isChecked ? "h-[250px]" : "h-[225px]"
          } flex justify-center items-center w-full sm:w-[80%] sm:mb-0 mb-4`}
        >
          {imageObject && imageObject.type === "application/pdf" ? (
            <div className="text-center w-[80%] overflow-hidden mx-auto">
              <img
                src={pdf_icon}
                alt="pdf_icon "
                className="rounded-[20px] text-center m-auto"
              />
              <p className="font-Mulish text-[#000] font-normal text-base">
                {imageObject.name}
              </p>
            </div>
          ) : (
            <img
              src={previewUrl}
              alt="Uploaded Preview"
              className="mx-auto  h-[200px]  rounded-[20px]"
              onError={(e) => (e.currentTarget.src = pdf_icon)}
            />
          )}
          <DeleteIcon
            onClick={() => onDelete(fieldName)}
            className="absolute cursor-pointer top-[10px] right-[10px]"
          />
        </div>
      ) : (
        <div
          className={`bg-[#EAECF0] py-5 w-full relative sm:w-[80%] text-center rounded-[20px] ${
            !isChecked ? "h-[250px]" : "h-[225px]"
          } `}
        >
          <div className="text-center mb-4">
            <UploadIcon />
          </div>
          <h6 className="text-[14px] font-normal text-darkgrey mb-3">
            Passport image
          </h6>
          <p className="text-[12px] font-normal text-[#98A2B3] w-[90%] sm:w-[80%] mx-auto mb-5">
            Upload the front side of the document supports: JPG, PNG, PDF
          </p>
          <div className="m-auto">
            <input
              type="file"
              accept="image/jpeg, image/png , application/pdf"
              {...register(fieldName, {
                required: !savedFileUrl ? "Passport image is required" : false,
              })}
              onChange={handleFileChange}
              ref={fileInputRef}
              hidden
            />
            <button
              type="button"
              disabled={isChecked}
              onClick={onChooseFileClick}
              className="border border-solid border-[#ccc] text-sm font-normal  text-[#585C7B]  rounded-full px-4 py-2"
            >
              Choose file
            </button>
          </div>
          {error && (
            <ErrorsMessage
              title={error?.message}
              className="absolute top-[100%] left-0"
            />
          )}
        </div>
      )}
    </div>
  );
};

export default memo(PassportImageUpload);
